/**
 * RFQ Redux helpers (HPRMS Phase B).
 */

import {
  getRequestForQuotations,
  getRfqById,
  mapRfqSnapshot,
} from "../apis/purchaseJourney.api";
import { RFQS_PAGE_SIZE } from "./purchaseJourneyConstants";

const getStore = () => require("../index").default;

export const findRfqInState = (rfqsState, id) => {
  if (id == null || String(id).trim().toLowerCase() === "null") return null;
  const key = String(id);
  const list = rfqsState?.rfqs || [];
  return list.find((r) => String(r?.POID ?? r?.id ?? "") === key) || null;
};

export const rfqsPresentInStore = (rfqsState) => {
  const state = rfqsState || getStore().getState()?.rfqsState;
  if (!state) return false;
  if (state.rfqsLoaded) return true;
  return (state.rfqs || []).length > 0;
};

export const isRfqDetailUsable = (rfq) =>
  Boolean(rfq && Array.isArray(rfq.lineItems) && rfq.lineItems.length > 0);

export const upsertRfqInStore = (rfq) => {
  if (!rfq) return;
  const id = rfq.POID || rfq.id;
  if (!id) return;
  getStore().dispatch({
    type: "UPSERT_RFQ",
    payload: { ...rfq, POID: id, id: rfq.id || id },
  });
};

export const applyRfqsToStore = (list) => {
  getStore().dispatch({
    type: "SET_RFQS",
    payload: Array.isArray(list) ? list : [],
  });
};

export const refreshRfqsInStore = async ({
  start = 0,
  size = RFQS_PAGE_SIZE,
  status = null,
  context = "Loading RFQs",
  silent = true,
} = {}) => {
  const list = await getRequestForQuotations({
    start,
    size,
    status: status || undefined,
    silent,
    hideLoader: silent,
    context,
  });
  applyRfqsToStore(list);
  return list;
};

export const ensureRfqsInStore = async ({
  force = false,
  silent = true,
  context = "Loading RFQs",
} = {}) => {
  if (!force && rfqsPresentInStore()) {
    return getStore().getState()?.rfqsState?.rfqs || [];
  }
  return refreshRfqsInStore({ silent, context });
};

export const resolveRfqById = async (id, { forceNetwork = false } = {}) => {
  const key = String(id ?? "").trim();
  if (!key || key.toLowerCase() === "null") return null;

  const store = getStore();
  if (!forceNetwork) {
    const fromStore = findRfqInState(store.getState()?.rfqsState, key);
    if (isRfqDetailUsable(fromStore)) return fromStore;
  }

  const full = await getRfqById(key);
  if (!full) return null;
  const stamped = { ...full, __detailFetched: true };
  upsertRfqInStore(stamped);
  return stamped;
};

export const stampRfqWrite = (id, data, lineItems = [], vendors = []) => {
  const snapshot = mapRfqSnapshot(id, data, lineItems, vendors);
  upsertRfqInStore({ ...snapshot, __detailFetched: true });
  return snapshot;
};
